<div class="mtest-medical-test-image-icon {{styleClass}}" [class.disabled]="![5,6,13,14,15].includes(requestStateId) || requestTypeId != 3">
  <a (click)="onClickMedicalImageMock()" class="pointer" pTooltip="{{'SI_MEDICAL_IMAGE' | translate}}" tooltipPosition="top">
    <i class="icosun-image-2 font-color-main1 mr-1"></i>
  </a>
  <a (click)="onClickMedicalReportMock()" class="pointer" pTooltip="{{'SI_RESULTS' | translate}}" tooltipPosition="top">
    <i class="icosun-show_via_clinica-1 font-color-main1"></i>
  </a>
</div>
